export default {
  methods: {
    errorHandling (error, callback) {
      const payload = {
        type: 'danger',
        vueInstance: this
      }
      if (callback) {
        payload.retryCallback = callback
        payload.isCanRetry = true
      }
      if (error.response) {
        const response = error.response
        if (response.status === 500 || response.status === 400) {
          payload.errorCode = response.status
          if (response.data.hasOwnProperty('message')) {
            payload.message = response.data.message
          } else if (response.data.hasOwnProperty('requestId')) {
            payload.message = response.data.error
            payload.details = error
          } else {
            payload.message = 'Unknown Error'
            payload.details = error
          }
        } else if (response.status === 502) {
          payload.errorCode = response.status
          if (response.status === 502) {
            payload.message = 'Server Bad Gateway'
          }
          if (!callback) {
            payload.isCanRetry = true
            payload.retryCallback = () => {
              location.reload()
            }
          }
        }
      } else if (error.message) {
        payload.message = error.message
        if (error.message === 'Network Error') {
          if (!callback) {
            payload.isCanRetry = true
            payload.retryCallback = () => {
              location.reload()
            }
          }
        }
      }
      this.$notifications.add(payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/errorHandling.js